import { render, staticRenderFns } from "./ShareNumberModal.vue?vue&type=template&id=52ccf0e8&"
import script from "./ShareNumberModal.vue?vue&type=script&lang=js&"
export * from "./ShareNumberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports